import { render } from "./CreateFolderOverlay.vue?vue&type=template&id=de184cd0"
import script from "./CreateFolderOverlay.vue?vue&type=script&lang=js"
export * from "./CreateFolderOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__